<script>
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: "StatusSelector",
  props: {
    modelValue: String,
  },
  emits: ['update:modelValue', 'mapChanges'],
  data() {
    const { t } = useI18n();
    return {
      t,
      statuses: [
        { key: 'cutting', nameKey: 'statuses.cutting' },
        { key: 'active', nameKey: 'statuses.active' },
        { key: 'closed', nameKey: 'statuses.closed' },
        { key: 'done', nameKey: 'statuses.done' },
        { key: 'work', nameKey: 'statuses.work' },
      ],
      localModelValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.localModelValue = newVal;
      this.$emit('mapChanges', 'status', newVal);
    }
  },
  computed: {
    mapStatusName() {
      const status = this.statuses.find(item => item.key === this.localModelValue);
      return this.t(status?.nameKey || '');
    }
  },
  methods: {
    updateStatus() {
      this.$emit('update:modelValue', this.localModelValue);
    }
  }
});
</script>

<template>
  <div class="form-group mb-3">
    <label class="mb-2" for="statusSelector">{{ t('labels.orderStatus') }}</label>
    <select
        class="form-select"
        id="statusSelector"
        v-model="localModelValue"
        @change="updateStatus"
    >
      <option
          v-for="status in statuses"
          :key="status.key"
          :value="status.key"
      >
        {{ t(status.nameKey) }}
      </option>
    </select>
  </div>
</template>

<style scoped lang="scss">
</style>
